import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ReCaptchaModule } from 'angular2-recaptcha';

import { EmailService } from '../shared/services/email.service';
import { SlackService } from '../shared/services/slack.service';
import { NotificationService } from '../shared/services/notification.service';

import { Contact } from '../shared/interfaces/contact.interface';

@Component({
	selector: 'app-contact',
	templateUrl: './contact.component.html',
	styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
	contactForm: FormGroup;

	public captchaState: boolean = false;

	constructor(
		private formBuilder: FormBuilder,
		private emailService: EmailService,
		private slackService: SlackService,
		private notificationService: NotificationService
	) {
		this.contactForm = this.formBuilder.group({
			name: [null, Validators.required],
			phone: [36, [Validators.required, Validators.minLength(10)]],
			email: [null, [Validators.required, Validators.email]],
			message: [null],
			legal: [false, Validators.pattern('true')],
			time: [null],
			status: [true]
		});
	}

	ngOnInit() { }

	public send(data: Contact): void {
		if(this.captchaState) {
			if (this.contactForm.controls['legal'].valid) {
				data.time = new Date().getTime();
				data.status = true;
				this.emailService.sendContact(data).subscribe(res => {
					// console.log('Success', res);
					this.notificationService.show('Kapcsolatfelvétel küldése sikeres!');
				}, error => {
					// console.log('Error', error);
					this.notificationService.show('Kapcsolatfelvétel küldése SIKERTELEN!');
				});
				this.slackService.sendContact(data);
				this.resetContactForm();
			}
			else {
				this.notificationService.show('Adatkezelési szabályzat elfogadása kötelező!');
			}
		}
	}

	public setCaptchaState(token: string, state: boolean): void {
		this.captchaState = state;
		state ? this.notificationService.show('Captcha elfogadva!') : this.notificationService.show('Captcha érvényessége lejárt!');
	}

	private resetContactForm(): void {
		this.contactForm.reset();
		this.contactForm.controls['phone'].setValue(36);
	}

}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts